import { Component, OnInit } from '@angular/core';
import { Observable } from 'src/app/classes/observable';

@Component({
  selector: 'app-mfa-activate-process',
  templateUrl: './mfa-activate-proccess.component.html',
  styleUrls: ['./mfa-activate-proccess.component.scss'],
})
export class MfaActivateProccessComponent implements OnInit {

  private validate= false;
  public qr;
  public manual;
  public code: string;
  public codigoInvalido = false;
  constructor() { }

  ngOnInit() {
    console.log("aca mfa-activate")
    Observable.suscribe("mfaQrActivate", (data)=>{
      this.validate = data;
    });
    Observable.suscribe("mfaQrVolver", (data)=>{
      this.volver();
    });
  }

  onValidate() {
    this.validate = true;
  }
  volver(){
    this.validate = false;
  }

  showQr(){
    return this.validate;
  }

  onChange(code:any){
    this.code = code;
  }
}
